import { ToastProgrammatic } from 'buefy'
import type { GraphQLError } from 'graphql'

export const displayErrors = (errors: any) => {
  if (!errors.graphQLErrors) {
    ToastProgrammatic.open({ message: errors.message, type: 'is-danger' })
    return
  }
  errors.graphQLErrors.forEach((error: GraphQLError) => {
    ToastProgrammatic.open({
      message: (error.extensions?.message as string) ?? error.message,
      type: 'is-danger',
      queue: false
    })
  })
}

export const requiredErrorMessage = 'This field is required'
